import useLazyData from '@/hooks/useLazyData';
import dynamic from 'next/dynamic';
import Skeleton from './skeleton';

const DynamicProductList = dynamic(() => import('./product-list'), {
  ssr: false,
  loading: Skeleton
});

const Banner = props => {
  const { ref: viewRef, show } = useLazyData({
    threshold: 0.01,
    rootMargin: '10px 0px 0px 0px'
  });

  const skeleton = <Skeleton />;

  if (!show) {
    return <div ref={viewRef}>{skeleton}</div>;
  }

  return <DynamicProductList skeleton={skeleton} {...props} />;
};

export default Banner;
